import React from "react";
import { EditBillings } from "../../../templates/payment/EditBillings";
import styles from "./CompanyBillingInfo.module.scss";
import { useTranslation } from "react-i18next";
import BillingInfoForm from "./BillingInfoForm";
import { NoticeType } from "../../../../types/settingsTypes";

type Props = {
  client: string;
  isPartner: boolean;
  is_internal: boolean;
  setNotice: React.Dispatch<React.SetStateAction<NoticeType>>;
  countryCode: string;
  locale: string;
};

const CompanyBillingInfo = ({ client, isPartner, is_internal, setNotice, countryCode, locale }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.formContent}>
        <h1 className={styles.title} data-testid="company-billing-info-settings-title">
          {t("CompanyBillingInfo.会社情報・請求先情報")}
        </h1>
        {is_internal ? (
          <EditBillings client={client} isPartner={isPartner} />
        ) : (
          <BillingInfoForm client={client} setNotice={setNotice} countryCode={countryCode} locale={locale} />
        )}
      </div>
    </>
  );
};

export default CompanyBillingInfo;
